export default {
  1: 'Conocimiento',
  2: 'Para gestión',
  3: 'Visto bueno'
};
